import { render, staticRenderFns } from "./FinanceTabOverview.vue?vue&type=template&id=2cb1fb49&scoped=true"
import script from "./FinanceTabOverview.vue?vue&type=script&lang=js"
export * from "./FinanceTabOverview.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabOverview.vue?vue&type=style&index=0&id=2cb1fb49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1fb49",
  null
  
)

export default component.exports